import { Component, ViewChild} from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { SocketService } from './shared/services/socket.service';
import { ChatService } from './pages/chat/chat.service';
import { AuthService } from './shared/services/auth.service';
import { MessageService } from './message.service';
import { PushNotificationsService } from './shared/services/push.notification.service';
import { ChatAdapter } from './pages/ng-chat/core/chat-adapter';
import { Observable } from 'rxjs';
import { Message } from './pages/ng-chat/core/message';
import { User } from './pages/ng-chat/core/user';
import { environment } from '../environments/environment';

declare var toastr;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ SocketService, ChatService, MessageService, PushNotificationsService ]
})
export class AppComponent {
  public settings: Settings;
  public isTestSite = !environment.production;
  private readonly urlBase = '/api/';
  loadAPI: Promise<any>;

  constructor(public appSettings: AppSettings, private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer, private chatService: ChatService, private messageService: MessageService, private notificationService: PushNotificationsService) {
      this.settings = this.appSettings.settings;

      /*this.loadAPI = new Promise((resolve) => {
        this.loadScript();
        resolve(true);
      });*/
      
      this.matIconRegistry.addSvgIcon(
        "evil_face",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/evil.svg")
      );

      matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('../assets/mdi.svg'));

      this.notificationService.requestPermission();

      
  }

  ngOnInit() {    
    
  }

  public loadScript() {        
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
        if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
            isFound = true;
        }
    }

    if (!isFound) {
        var dynamicScripts = ["assets/libs/js/toastr.min.js","assets/libs/js/jquery.min.js"];

        for (var i = 0; i < dynamicScripts.length; i++) {
            let node = document.createElement('script');
            node.src = dynamicScripts [i];
            node.type = 'text/javascript';
            node.async = false;
            node.charset = 'utf-8';
            document.getElementsByTagName('head')[0].appendChild(node);
        }

    }
}


}